<template lang="pug">
div
    v-card.mt-3.transparent(style="backdrop-filter:blur(10px);")
        v-card-text(style="background-color:rgba(0,0,0,0.1);")
            v-form(v-model="validateUploadForm")
                v-layout(row wrap)
                    v-flex(xs12).text-center.pt-3
                        h3 Datos del solicitante
                    v-flex(xs8)
                        v-text-field(
                            label="CI (Del solicitante):"
                            outlined
                            v-mask="'cccccccccccc'"
                            :rules="$rules.ci"
                            v-model="dataUploadDec.ci"
                            autocomplete="off"
                            ref="refsUploadDecCi"
                            :hide-details="refsUploadDec.ci"
                            @update:error="refsUploadDec.ci = $refs.refsUploadDecCi.valid"
                            @blur="refsUploadDec.ci = $refs.refsUploadDecCi.valid"
                            @keydown="refsUploadDec.ci = $refs.refsUploadDecCi.valid")
                    v-flex(xs4)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Expedido:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs12).text-center.pt-3
                        h3 Datos del beneficiario
                    v-flex(xs8)
                        v-text-field(label="CI (Del beneficiario):" outlined hide-details)
                    v-flex(xs4)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Expedido:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Departamento:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Distrito:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs6)
                        v-text-field(label="Programa:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="RDA:" outlined hide-details)
                    v-flex(xs12)
                        v-text-field(label="Nombres:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="Apellido Paterno:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="Apellido Materno:" outlined hide-details)
                    v-flex(xs12).text-center.pt-3
                        h3 Registro de la baja temporal
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Gestión:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="mes:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs6)
                        v-text-field(label="Teléfono:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="Correo electrónico:" outlined hide-details)
                    v-flex(xs12)
                        h4.pb-2 Tipo baja:
                        v-radio-group(row hide-details).no-margin
                            v-radio(label="Maternidad Prenatal").mb-2.mr-12
                            v-radio(label="Maternidad Postnatal").mb-2
                            v-radio(label="Enfermedad").mb-2.mr-12
                            v-radio(label="Accidente de trabajo" style="margin-left:58px !important;").mb-2
                    v-flex(xs6)
                        v-text-field(label="Fecha inicio:" outlined hide-details append-icon="far fa-calendar-alt")
                    v-flex(xs6)
                        v-text-field(label="Fecha fin:" outlined hide-details append-icon="far fa-calendar-alt")
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Seguro:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Regional:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs12)
                        v-text-field(label="Código de asegurado:" outlined hide-details)
        v-card-actions(style="background-color:rgba(0,0,0,0.1);")
            v-spacer
            v-btn.success.txtn(large :loading="isLoading" @click="subirArchivoDec") Generar solicitud&nbsp;
                v-icon fas fa-file-alt
            v-spacer
    v-card.transparent.mt-5(style="backdrop-filter:blur(10px);")
        v-card-text(style="background-color:rgba(0,0,0,0.1);").text-center
            | Puede consultar sus solicitudes de baja temporal generadas, ingresando el C.I. del beneficiario:
        v-card-text.pt-1(style="background-color:rgba(0,0,0,0.1);")
            v-text-field(label="CI (Numero de documento):" outlined hide-details v-mask="'cccccccccccc'")
                template(v-slot:append-outer)
                    v-btn(color="success" @click="dialogUltimosDec=true" style="margin-top:-5px").txtn Verificar
    v-dialog(v-model="dialogConfirm" width=400)
        v-card
            v-toolbar(dark color="success" dense).no-padding.no-margin
                v-toolbar-title Archivo subido.
                v-spacer
                v-btn(icon dark @click="dialogConfirm = false")
                    v-icon fas fa-times
            v-card-text.text-center.pb-5
                h3.pt-3 Su archivo fué subido correctamente al servidor, puede verificarlo mas adelante con su ci:
                h3.pt-2 4687156
                v-btn(color="success" @click="dialogConfirm = false").mt-2 Aceptar
</template>
<script>
export default {
    data() {
        return {
            dataUploadDec: {
                ci: null,
                mes: null,
                anio: null,
                dec: null
            },
            dialogConfirm: false,
            isLoading: false,
            validateUploadForm: false,
            refsUploadDec: {
                ci: true,
                dec: true
            }
        }
    },
    computed: {
        //
    },
    mounted() {
        //this.ciDetails = true
    },
    methods: {
        async subirArchivoDec(){
            try{
                // Check form validation
                // check captcha
                // init progress in button
                let response = await axios({
                    method: 'post',

                })
                // stop progress in button
                console.log('Data', this.dataUploadDec)
            }
            catch(e){
                this.$snotify.info('Error catch')
                // stop progress in button
            }
        }
    }
}
</script>